import React from 'react';
import { Button, Heading } from '@digitools/honest-react';
import styled from 'styled-components';
import useTranslate from '../../hooks/useTranslate';
import useAuthentication from '../../hooks/useAuthentication';
import ResetPassword from './resetPassword/ResetPassword';
import { SecurityAndSettingsText } from './i18n/SecurityAndSettingsText';
import withGoogleAnalytics from '../../hocs/WithGoogleAnalytics';
import { getEnvVariable } from '../../utils/envUtils';
const StyledHRElement = styled('hr') `
  margin: 1rem 0 1.5rem;
`;
const StyledHeading = styled(Heading) `
  font-family: "PublicoBanner-Light", "Publico Banner Light", "Publico Banner", sans-serif;
  font-weight: 200 !important;
  font-style: normal;
  font-size: 34px !important;
`;
const LfgEmployeePasswordReset = () => {
    const { t } = useTranslate();
    const { logout } = useAuthentication();
    return (<>
      <Heading data-public={true} elemType={'h2'} elemStyle={'h3'} color={'black'} id='resetPasswordHeading'>
        {t(SecurityAndSettingsText.resetPWHeading)}
      </Heading>
      <p data-public={true}>
        {t(SecurityAndSettingsText.resetPWLfgEmployeeMsg)}
      </p>
      <Button data-public={true} data-testid='lfg-employee-reset-confirm' id='lfg-employee-reset-confirm' onClick={() => logout(getEnvVariable('lfgPublicPasswordResetUrl'))} buttonType={'primary'}>
        {t(SecurityAndSettingsText.btnResetPassword)}
      </Button>
    </>);
};
const SecurityAndSettingsContainer = () => {
    const { t } = useTranslate();
    const { user } = useAuthentication();
    return (<>
      <StyledHeading data-public={true} elemType={'h2'} elemStyle={'h3'} color={'primary'} data-testid="security-and-settings-heading">
        {t(SecurityAndSettingsText.profileHeading)}
        </StyledHeading>
        <StyledHRElement />

        {(user?.auth0Roles?.includes('MLPEmployee') && !user?.isIdentityVerified) ?
            <LfgEmployeePasswordReset /> :
            <ResetPassword data-testid="reset-password"></ResetPassword>}
    </>);
};
export default withGoogleAnalytics(SecurityAndSettingsContainer);
